import { initFancybox } from '@js/common/fancyboxInit.js';
initFancybox();